<template>
  <div class="container">

    <v-card>
      <v-card-title class="blue accent-1 gray--text">Listado de bins</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  right
                  @click="dialog = !dialog"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Ingresar nuevo bin al sistema</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  dark
                  right
                 @click="upload = !upload"
                  v-on="on"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Carga masiva de bins</span>
            </v-tooltip>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Escriba para filtrar bins"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table 
        :headers="binsListHeaders"
        :items="binsListBody"
        class="elevation-3 mt-5"
        no-data-text="No hay bins"
        :search="search"
    >
      <template v-slot:[`item.purchase_date`]="{item}">
          {{ formatDate(item.purchase_date) }}
      </template>
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="showState(item)"
              v-on="on"
            >
              mdi-heart-pulse
            </v-icon>
          </template>
          <span>Cambiar estado del Bin</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editBin(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar datos del Bin</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
                medium
                @click="inactivateBin(item)"
                v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Dar de baja Bin</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Modal Nuevo Bin -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue accent-1 gray--text">
          Crear Bin
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="4"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Número"
                v-model="bin.number"
                label="Número"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select 
                prepend-icon="mdi-factory"
                v-model="bin.company"
                :items="companies"
                item-text="name"
                item-value="id"
                label="Propietario"
                color="blue darken-3"
                persistent-hint
                return-object
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select 
                prepend-icon="mdi-format-color-fill"
                v-model="bin.color"
                :items="colors"
                item-text="name"
                item-value="id"
                label="Color"
                color="blue darken-3"
                persistent-hint
                return-object
              >
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                prepend-icon="mdi-move-resize"
                v-model="bin.size"
                :items="sizes"
                item-text="name"
                item-value="id"
                label="Tamaño"
                color="blue darken-3"
                persistent-hint
                return-object
              >
              </v-select>
            </v-col>
            <v-col
              class="align-center justify-space-between"
              cols="4"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Código"
                label="Código"
                v-model="setCode"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                prepend-icon="mdi-file-document"
                placeholder="Guía Despacho"
                label="Guía Despacho"
                v-model="bin.waybill"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <date-picker v-model="bin.purchase_date" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveBin"
              >Grabar</v-btn>
        </v-card-actions>
              
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <!-- Modal upload -->
    <v-dialog
      v-model="upload"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Subir archivo de bins
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="upload = false"
          >Cerrar</v-btn>
          <v-btn
            color="primary"
            @click="uploadBins"
          >Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <!-- Modal upload -->
    <v-dialog
      v-model="changeState"
      width="600px"
    >
      <v-card>
        <v-card-title class="blue darken-2">
          Cambio de estado del bin
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-select
              v-model="state"
              :items="states"
              item-text="name"
              item-value="id"
              label="Estado del bin"
              color="blue darken-3"
              persistent-hint
              return-object>
            </v-select>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="changeState = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="changeBinState"
          >Cambiar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  //datepicker vue2
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
      errors: [],
      snackbar: false,
      color: 'green',
      validation_message: '',
      search: null,
      file: null,
      dialog: false,
      upload: false,
      changeState: false,
      companies: [],
      colors: [],
      sizes: [],
      state: null,
      states: [],
      binIndex: -1,
      bin: {
        id: 0,
        code: '',
        number: '',
        color: null,
        size: null,
        company: null,
        waybill: '',
        purchase_date: new Date().toISOString().substr(0, 10),
      },
      binsListHeaders: [
        {
          text: 'Numero',
          align: 'center',
          sortable: true,
          value: 'number',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Propietario',
          align: 'center',
          sortable: true,
          value: 'company.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'code',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Fecha Compra',
          align: 'center',
          sortable: true,
          value: 'purchase_date',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-3"
        },
      ],
      binsListBody: [],
    }),
    mounted() {
      this.loadColors();
      this.loadSizes();
      this.loadStates();
      this.loadCompanies();
      this.loadBins();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companies = response.data.data;
            this.bin.company = this.companies[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.colors = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.states = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        this.mostrarLoading('Cargando listado de bins...');
        let url = `${this.base_url}bins`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.binsListBody = response.data.data;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      async saveBin(){
        // validation
        this.errors = [];
        if(!this.bin.number){
          this.errors.push("Debe indicar número de bin");
        }
        if(this.bin.size == null){
          this.errors.push("Debe seleccionar un tamaño");
        }
        if(this.bin.color == null){
          this.errors.push("Debe seleccionar un color");
        }
        if(!this.bin.waybill || isNaN(this.bin.waybill ) || this.bin.waybill <= 0){
          this.errors.push("Debe indicar guía de despacho");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}bins`;
        let binData = {
          'code': this.setCode,
          'company_id': this.bin.company.id,
          'number': this.bin.number,
          'colors_id': this.bin.color.id,
          'sizes_id': this.bin.size.id,
          'waybill': this.bin.waybill,
          'purchase_date': this.bin.purchase_date
        };
        if(this.bin.id > 0){
          url = url + "/" + this.bin.id;
          await this.axios.put(url, binData, this.headers).then((response)=>{
            //console.log(this.binsListBody);
            let index = this.binsListBody.map(bin => {
              return bin.id;
            }).indexOf(this.bin.id);
            this.binsListBody.splice(index, 1, response.data.data);
            this.dialog = false;
            this.showSnackBar(false);
          }).catch((error)=>{
              this.errors = error.response.data.data;
              this.validation_message = this.errors.join();
              this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, binData, this.headers).then((response)=>{
              this.binsListBody.push(response.data.data);
              this.showSnackBar(false);
          }).catch((error)=>{
              this.errors = error.response.data.data;
              this.validation_message = this.errors.join();
              this.showSnackBar(true);
          });
        }
      },
      editBin(item) {
        this.binIndex = this.binsListBody.indexOf(item)
        this.bin = Object.assign({}, item)
        this.dialog = true
      },
      deleteBin(item) {
        this.$confirm('Desea borrar este bin?').then(res => {
          if(res){
            const index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1);
          }
        });
      },
      showState(item){
        this.bin = item;
        this.changeState = true;
      },
      changeBinState(){
        let url = `${this.base_url}bins/change/state/${this.bin.id}/${this.state.id}`;
        this.axios.get(url, this.headers).then((response)=>{
          const bin = response.data.data;
          const index = this.binsListBody.indexOf(bin);
          this.binsListBody.splice(index, 1);
          this.showSnackBar(false);
        }).catch((error)=>{
          console.log(error);
          this.validation_message = "Error al inactivar bin";
          this.showSnackBar(true);
        });
      },
      closeModal(){
        this.dialog = false;
        this.error = null;
        this.error_message = "";
        this.bin.number = "";
        this.bin.waybill = "";
        this.bin.code = "";
        this.bin.color = null;
        this.bin.size = null;
        this.bin.company = null;
      },
      async inactivateBin(item) {
        this.$confirm('Desea dar de baja este bin?').then(res => {
          if(res){
            let url = `${this.base_url}bins/inactive/${item.id}`;
            this.axios.put(url, {active: 0}, this.headers).then((response)=>{
              console.log(response);
              const index = this.binsListBody.indexOf(item);
              this.binsListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              console.log(error);
              this.validation_message = "Error al borrar bin";
              this.showSnackBar(true);
            });
          }
        });
      },
      async uploadBins(){
        if(!this.file){
          this.validation_message = "Debe subir un archivo Excel";
          this.showSnackBar(true);
          return;
        }
        this.headers.headers['Content-Type'] = "multipart/form-data";
        let url = `${this.base_url}bins/upload`;
        let formData = new FormData();
        formData.append("excel", this.file);
        await this.axios.post(url, formData, this.headers).then((response)=>{
          console.log(response.data.data);
          this.file = null;
          this.upload = false;
          this.loadBins();
          this.showSnackBar(false);
        }).catch((response)=>{
          console.log(response);
          this.validation_message = "Formato de archivo no válido";
          this.showSnackBar(true);
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers']),
      setCode: function(){
        let company = this.bin.company == null ? '': this.bin.company.short_name;
        let color = this.bin.color == null ? '': this.bin.color.name;
        let size = this.bin.size == null ? '': this.bin.size.name;
        return company + ' ' + color + ' ' + size + ' #' + this.bin.number;
      }
    },
    components:{
      DatePicker
    }
  }
</script>
